import { render, staticRenderFns } from "./hrd-trainee-course-complete.vue?vue&type=template&id=65f3f858&scoped=true"
import script from "./hrd-trainee-course-complete.vue?vue&type=script&lang=js"
export * from "./hrd-trainee-course-complete.vue?vue&type=script&lang=js"
import style0 from "./hrd-trainee-course-complete.vue?vue&type=style&index=0&id=65f3f858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3f858",
  null
  
)

export default component.exports